<template>
  <v-container class="pb-0">
    <v-data-table
      :headers="canEditTasks ? headers : headers.slice(0, -1)"
      :loading="tasks.loading"
      :items="tasks.items"
      item-key="task_id"
      sort-by="date"
      sort-desc
      multi-sort
      height="350"
      fixed-header
      class="task-table"
      style="margin-top: -15px; z-index: 0; position: relative; margin-bottom: 0;"
    >
      <template #item.body="{value}">
        <div v-html="$sanitize(value)" />
      </template>
      <template #item.author_id="{value}">
        <template v-if="operatorsById">
          {{ operatorsById[value]?.login || ' - ' }}
        </template>
        <v-progress-circular v-else />
      </template>
      <template #item.user_id="{value}">
        <template v-if="operatorsById">
          {{ operatorsById[value]?.login || ' - ' }}
        </template>
        <v-progress-circular v-else />
      </template>
      <template #item.performer_id="{value}">
        <template v-if="operatorsById">
          {{ operatorsById[value]?.login || ' - ' }}
        </template>
        <v-progress-circular v-else />
      </template>
      <template #item.action="{ item }">
        <div style="white-space: nowrap">
          <v-icon small @click="editItem(item)">
            edit
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            delete
          </v-icon>
        </div>
      </template>

      <template #item.type="{value}">
        {{ TYPE_OPTIONS[value] }}
      </template>
      <template #item.status="{value, item}">
        <v-select
          v-if="canEditTasks"
          :value="value"
          :items="Object.entries(STATUS_OPTIONS)"
          item-value="0"
          item-text="1"
          hide-details
          class="mt-0 pt-0"
          dense
          style="font-size: 11pt; max-width: 100px;"
          @change="onInlineStatusEdit($event, item)"
        />
        <template v-else>
          {{ STATUS_OPTIONS[value] }}
        </template>
      </template>
      <template #no-data>
        <v-btn @click="$store.dispatch('account/loadTasks', { account: activeAccount.account })" icon fab class="mt-4">
          <v-icon x-large>refresh</v-icon>
        </v-btn>
      </template>
      <template #footer.page-text="{ pageStart , pageStop , itemsLength }">
        {{ pageStart }} - {{ pageStop }} of {{ itemsLength }}
        <v-btn @click="$store.dispatch('account/loadTasks', { account: activeAccount.account })" icon style="margin-right: -35px;">
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
      <template #footer.prepend>
        <v-dialog v-model="dialog" max-width="900" style="overflow: initial">
          <template #activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on" @click="editedItem = getEmptyTask()" icon>
              <v-icon>add</v-icon>
            </v-btn>
          </template>

          <task-form
            v-if="editedItem"
            :task="editedItem"
            :operators-by-id="operatorsById"
            :operator-id="$store.state.auth.user.user_id"
            :can-assign-to-other-people="canAssignToOtherPeople"
            :is-loading="tasks.loading"
            is-login-readonly
            @close="close"
            @save="save"
          />
        </v-dialog>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'
  import { STATUS_OPTIONS, TYPE_OPTIONS, TaskForm } from '@/modules/tasks'
  import { keyBy } from 'lodash'
  import moment from 'moment'
  const USER_LIST = '/users/list_info.json'

  export default {
    components: {
      TaskForm
    },
    props: [ 'type' ],

    data: () => ({
      dialog: false,
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Body', value: 'body', sortable: false },
        { text: 'Author', value: 'author_id', sortable: false },
        { text: 'Assignee', value: 'user_id', sortable: false },
        { text: 'Performer', value: 'performer_id', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Status', align: 'left', sortable: false, value: 'status', width: '15%' },
        { text: 'Done At', align: 'left', sortable: false, value: 'done', },
        { text: 'Actions', value: 'action', sortable: false, width: '75px' }
      ],
      editedIndex: -1,
      editedItem: null,
      STATUS_OPTIONS,
      TYPE_OPTIONS,
      operatorsById: null
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active', tasks: 'account/tasks' }),
      canAssignToOtherPeople() {
        return this.$store.state.auth.checkAccess({key: 'task_assignment', value: true})
      },
      canEditTasks() {
        return this.$store.state.auth.checkAccess({key: 'task_control', value: true})
      },
      operatorId() {
        return this.$store.state.auth.user.user_id
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    mounted () {
      this.loadOperators();
    },

    methods: {
      async onInlineStatusEdit(status, item) {
        if (await this.$root.$confirm('Confirm', 'Are you sure you want to edit this item?')) {
          this.save({
            ...item,
            status
          })
        }
      },
      editItem (item) {
        this.editedItem = item
        this.dialog = true
      },

      loadOperators() {
        return API.call(USER_LIST).then(response => this.operatorsById = keyBy(response.data, 'user_id'));
      },

      async deleteItem (item) {
        if (await this.$root.$confirm('Confirm', 'Are you sure you want to delete this item?')) {
          this.$store.dispatch('account/deleteTask', {
            task_id: item.task_id,
            account: this.activeAccount.account
          }).then(this.close)
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = null
        }, 300)
      },

      save (task) {
        return this.$store.dispatch('account/updateTask', {
          account: this.activeAccount.account,
          task
        }).then(this.close);
      },

      getEmptyTask() {
        return {
          player_id: this.activeAccount.account.account_id,
          player_login: this.activeAccount.account.login,
          date: moment().format('YYYY-MM-DD'),
          user_id: this.canAssignToOtherPeople ? null : this.operatorId,
          performer_id: this.canAssignToOtherPeople ? null : this.operatorId,
          body: '',
          priority: 'low',
          status: 'new',
          type: 'general',
        }
      }
    },
  }
</script>
